import useTranslation from 'next-translate/useTranslation';
import { ReactElement } from 'react';
import { SwitchField } from '@components/form';
import { accordionSwitchSx } from '@utils/consts/switchAccordion';
import { FormProps } from '@utils/types/form';

const AiSearchFields = (formProps: FormProps): ReactElement => {
    const { t } = useTranslation('common');

    return (
        <>
            <SwitchField
                inputSx={accordionSwitchSx}
                label={t('print.aiSearchModal.exportFollowupQuestions')}
                name="withFollowupQuestions"
                {...formProps}
            />
            <SwitchField
                inputSx={accordionSwitchSx}
                label={t('print.aiSearchModal.exportCitedPublications')}
                name="withAssociatedDocuments"
                {...formProps}
            />
        </>
    );
};

export default AiSearchFields;
